import React from "react";

import { CommonIntroContactDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyAaaContactProps = {
  dataInForm: CommonIntroContactDataType;
};

const ContactConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["firstName", {}],
  ["lastName", {}],
  ["email", {}],
]);

export const ReadOnlyAaaContact = ({ dataInForm }: ReadOnlyAaaContactProps) => (
  <ReadOnlyForm formConfig={ContactConfig} formData={dataInForm} />
);
